// "Soft power" podcast: only full episodes are shown. Full episodes are
// published on Thursdays (Europe/Warsaw) on the Zwierciadło YouTube channel
// and mention "Soft power" in the description; fragments/clips appear on other days.

export const ZWIERCIADLO_CHANNEL_ID = "UCfpwW1pb0ClbVaiLg6AusBg";
export const PODCAST_FEED_URL = `https://www.youtube.com/feeds/videos.xml?channel_id=${ZWIERCIADLO_CHANNEL_ID}`;

export type PodcastEpisode = {
  videoId: string;
  title: string;
  published: string; // ISO
};

/** Known full episodes — the YouTube feed only lists the newest ~15 videos. */
export const archivedEpisodes: PodcastEpisode[] = [
  {
    videoId: "dq4yFJUCNqE",
    title: "„Jak nas zalewa trudna emocja, to ćwiczymy izometrię”. Prof. Rafał Ohme o spalaniu kortyzolu",
    published: "2026-10-01T11:30:46Z",
  },
  {
    videoId: "Qa-giIA90bg",
    title: "„Jestem wdzięczna za trudne momenty”. Joanna Jędrzejczyk o psychologicznych grach",
    published: "2026-10-08T10:34:36Z",
  },
];

export function isWarsawThursday(iso: string): boolean {
  const day = new Intl.DateTimeFormat("en-US", { weekday: "short", timeZone: "Europe/Warsaw" }).format(new Date(iso));
  return day === "Thu";
}

export function isFullEpisode(entry: { published: string; description: string }): boolean {
  return /soft\s*power/i.test(entry.description) && isWarsawThursday(entry.published);
}

function decode(s: string) {
  return s
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&amp;/g, "&");
}

export function parseFeed(xml: string): PodcastEpisode[] {
  const out: PodcastEpisode[] = [];
  for (const chunk of xml.split("<entry>").slice(1)) {
    const videoId = chunk.match(/<yt:videoId>([^<]+)</)?.[1];
    const title = chunk.match(/<title>([^<]*)</)?.[1];
    const published = chunk.match(/<published>([^<]+)</)?.[1];
    const description = chunk.match(/<media:description>([\s\S]*?)<\/media:description>/)?.[1] ?? "";
    if (!videoId || !title || !published) continue;
    if (isFullEpisode({ published, description: decode(description) })) {
      out.push({ videoId, title: decode(title), published });
    }
  }
  return out;
}

export function mergeEpisodes(...lists: PodcastEpisode[][]): PodcastEpisode[] {
  const map = new Map<string, PodcastEpisode>();
  for (const list of lists) for (const e of list) if (!map.has(e.videoId)) map.set(e.videoId, e);
  return [...map.values()].sort((a, b) => b.published.localeCompare(a.published));
}

export function formatEpisodeDate(iso: string) {
  return new Intl.DateTimeFormat("pl-PL", { day: "numeric", month: "long", year: "numeric", timeZone: "Europe/Warsaw" }).format(new Date(iso));
}
